import React, { useState, useContext, useEffect, useCallback } from 'react';
import { modifyData, setAnalyticsData, getStoreDetails } from '../HeaderUtilities/HeaderUtils';
import { useHistory } from 'react-router-dom';
import {
  isEmptyEvery,
  getValueOrDefaultObject,
  getTernaryValue,
  checkTimeDuration,
  setUpdateCounter,
} from 'common/utilities/utils';
import { getUpdateTimeBasedCategory } from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { useDispatch, useSelector } from 'react-redux';
import {
  Config,
  LOCAL_STORAGE_KEYS,
  TO_CATERING_NAV,
  TO_MENU_NAV,
  IMAGE_SIZE_CONSTANTS,
} from 'common/constants/SharedConstants';
import OrderLookup from 'organisms/FooterComponent/AU/Presentation/orderLookUp';
import { HeaderComponentItems } from '../Presentation/HeaderComponentItems';
import { HamburgerMenuComp } from 'organisms/HamburgerMenu/Container/HamburgerMenuComp';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import HEADER_CONSTANT from '../HeaderConstants/HeaderConstant';
import {
  CateringMenuNavigationHandler,
  checkIfCateringPage,
  ifCateringNavigationHappened,
} from 'common/utilities/CateringPLPUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { STORE_CLOSING_SOON_MODAL_TIMING } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import DynamicMenuAlertComponent from '../../../../molecules/DynamicMenuAlert/AU/Container/DynamicMenuAlertComponent';

const { Timeout } = IMAGE_PATH;
const { STORE_CLOSING_SOON, STORE_CLOSE_SOON_CONTENT, COMPLETE_ORDER_BUTTON, FIND_NEARBY_STORE } =
  TRANSLATE_MAPPING_KEY;

/**
 * Method to hold user header item click
 */

const onHeaderItemSelect = ({
  headerItemSelected,
  pathname,
  userOrderStateDispatch,
  userParams,
  dispositionNew,
  setShowHamburger,
  history,
  setShowOrderLookupModal,
}) => {
  const { CATERING_NAVALERT_TITLE, CATERING_NAVALERT_SUBTITLE, MENU_NAVALERT_TITLE, MENU_NAVALERT_SUBTITLE } =
    TRANSLATE_MAPPING_KEY;
  setAnalyticsData({ headerItemSelected });
  setShowHamburger(false);

  if (headerItemSelected === HEADER_CONSTANT.CART) {
    history.push({
      pathname,
    });
  } else if (headerItemSelected?.name === START_ORDER_CONSTANTS.ORDER_LOOKUP) {
    setShowOrderLookupModal(true);
  } else if (pathname) {
    //if user is localized and menupage navigation is happening make usernonlocalized and clear cart
    let checkMenuNavigation = ifCateringNavigationHappened(userParams.localized, dispositionNew?.type, pathname);
    switch (checkMenuNavigation) {
      case TO_CATERING_NAV:
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.UPDATE_CATERING_RETAIL_MENU_ALERT,
          value: {
            flag: true,
            pathname,
            title: CATERING_NAVALERT_TITLE,
            contentMsg: CATERING_NAVALERT_SUBTITLE,
          },
        });
        break;
      case TO_MENU_NAV:
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.UPDATE_CATERING_RETAIL_MENU_ALERT,
          value: {
            flag: true,
            pathname,
            title: MENU_NAVALERT_TITLE,
            contentMsg: MENU_NAVALERT_SUBTITLE,
          },
        });
        break;
      default:
        history.push({
          pathname,
        });
        break;
    }
  }
};

/**
 * Main Container for Entire Header Components
 * @param - json data from content side
 */

const Header = props => {
  const { contentData = {} } = props;
  const { MENU_LINK_IMAGES } = IMAGE_SIZE_CONSTANTS;
  const { MENU_IMAGE_HEIGHT_MOBILE, MENU_IMAGE_WIDTH_MOBILE } = MENU_LINK_IMAGES;
  const [showHamburger, setShowHamburger] = useState(false);
  const [showOrderLookupModal, setShowOrderLookupModal] = useState(false);
  const [counter, setCounter] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { alertModalData = {}, timeBasedCetegory } = userOrderState;
  const dispatch = useDispatch();
  const history = useHistory();
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const tenantReducer = useSelector(data => data?.tenantReducer);
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const { CartError } = IMAGE_PATH;
  const { START_NEW_ORDER, KEEP_ORDER } = TRANSLATE_MAPPING_KEY;
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionNew),
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW)),
    userOrderState.dispositionNew,
  );

  const { basic, country, tenantId } = tenantReducer;

  const { navLeft, navRight, kfcLogo, navMobileMenu, languageObj } = modifyData(contentData, basic, country);

  const handleClose = () => {
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.UPDATE_CATERING_RETAIL_MENU_ALERT,
      value: {
        flag: false,
        pathname: '',
        title: '',
        contentMsg: '',
      },
    });
  };

  const onConfirmHandler = () => {
    //call util function
    CateringMenuNavigationHandler(
      cartData?.id,
      tenantId,
      userParams,
      dispatch,
      userOrderStateDispatch,
      checkIfCateringPage(alertModalData.pathname),
      dispositionNew,
    );
    //navigate to required page
    history.push({
      pathname: alertModalData.pathname,
    });
    //close disposition
    handleClose();
  };

  /* istanbul ignore next */
  const onClickBtnHandler = () => {
    setIsModalOpen(false);
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.SEARCH_ORDER_DATA, value: { showSearchStore: true } });
  };
  const getUpdateStoreDetails = () => {
    return storeData?.storesWithStatus && getStoreDetails(storeData?.storesWithStatus[0]);
  };
  const getStoreDetail = getUpdateStoreDetails();
  const timeIntervalSec = 15000; // 15sec
  const getClearInterval = useCallback(
    checkTime => {
      return counter ? clearInterval(checkTime) : null;
    },
    [counter],
  );

  useEffect(() => {
    const timer = () => {
      const calculateTimeDiff = checkTimeDuration(
        storeData?.storesWithStatus[0]?.summary,
        config(STORE_CLOSING_SOON_MODAL_TIMING),
        true,
      );
      if (!timeBasedCetegory?.isTimeExpired) {
        getUpdateTimeBasedCategory(timeBasedCetegory, cartReducer, userOrderStateDispatch);
      }
      setUpdateCounter(dispositionNew, cartReducer, calculateTimeDiff, setCounter);
    };

    const checkTime = setInterval(timer, timeIntervalSec);
    getClearInterval(checkTime);

    if (
      timeBasedCetegory &&
      timeBasedCetegory?.foodLinesItems?.length &&
      timeBasedCetegory?.foodLinesItems?.length !== cartReducer?.cartData?.foodLines?.length
    ) {
      getUpdateTimeBasedCategory(timeBasedCetegory, cartReducer, userOrderStateDispatch);
    }
    return () => {
      clearInterval(checkTime);
    };
  }, [
    counter,
    storeData?.storesWithStatus,
    dispositionNew,
    cartReducer?.cartData?.foodLines?.length,
    getClearInterval,
    cartReducer,
    timeBasedCetegory,
    userOrderStateDispatch,
  ]);

  const navigateHandler = (headerItemSelected, pathname) => {
    onHeaderItemSelect({
      headerItemSelected,
      pathname,
      userOrderStateDispatch,
      userParams,
      dispositionNew,
      setShowHamburger,
      history,
      setShowOrderLookupModal,
    });
  };

  return (
    <div
      className='root-header au'
      data-testid='HeaderItems-component'
      role='banner'
      data-id={Config.HEADER_ATTR_DATA_ID}
    >
      <HeaderComponentItems
        history={history}
        navRight={navRight}
        headerLinks={navLeft}
        kfcLogo={kfcLogo}
        languageObj={languageObj}
        onNavigateHandler={(headerItemSelected, pathname) => navigateHandler(headerItemSelected, pathname)}
        openHamburger={() => setShowHamburger(true)}
      />

      {getTernaryValue(
        showHamburger,
        <HamburgerMenuComp
          showHamburger={showHamburger}
          closeHamburger={() => setShowHamburger(false)}
          navRight={navRight}
          navLeft={navLeft}
          menuImageWidth={MENU_IMAGE_WIDTH_MOBILE}
          menuImageHeight={MENU_IMAGE_HEIGHT_MOBILE}
          languageObj={languageObj}
          navMobileMenu={navMobileMenu}
          onNavigateHandler={(headerItemSelected, pathname) => navigateHandler(headerItemSelected, pathname)}
        />,
        null,
      )}
      {showOrderLookupModal && <OrderLookup isOpen={true} handleClose={() => setShowOrderLookupModal(false)} />}
      {getTernaryValue(
        alertModalData.flag,
        <CartAlertFormInsideModel
          handleClose={handleClose}
          classNames='clear-cart-modal item-unavailable catering-menu-nav-alert'
          CartAlertForm={
            <CartAlertForm
              title={translateWithI18Next(alertModalData.title)}
              contentMsg={translateWithI18Next(alertModalData.contentMsg)}
              imageSrc={CartError}
              altText={''}
              confirmButtonText={translateWithI18Next(START_NEW_ORDER)}
              confirmHandler={onConfirmHandler}
              cancelButtonText={translateWithI18Next(KEEP_ORDER)}
              cancelHandler={handleClose}
            />
          }
        />,
        <></>,
      )}
      {/* Show 45min left screen */}
      {getTernaryValue(
        isModalOpen,
        <CartAlertFormInsideModel
          data-testid='alert-modal'
          handleClose={() => setIsModalOpen(false)}
          classNames='clear-cart-modal item-unavailable store-time-msg'
          CartAlertForm={
            <CartAlertForm
              splitTitle={{
                MSGTXT2: `${getStoreDetail?.storeName}`,
                MSGTXT3: `${translateWithI18Next(STORE_CLOSING_SOON)}`,
              }}
              contentMsg={translateWithI18Next(STORE_CLOSE_SOON_CONTENT)}
              imageSrc={Timeout}
              cancelButtonText={translateWithI18Next(FIND_NEARBY_STORE)}
              cancelHandler={onClickBtnHandler}
              confirmButtonText={translateWithI18Next(COMPLETE_ORDER_BUTTON)}
              confirmHandler={() => setIsModalOpen(false)}
            />
          }
        />,
        null,
      )}
      <DynamicMenuAlertComponent />
    </div>
  );
};

export default Header;
